import React, {useEffect} from 'react';
import lottie from 'lottie-web';
import {animations} from "../utils/animation";
import {useStoreState, useStoreActions} from "easy-peasy";

const Lottie = () => {
    const {
        loop,
        autoplay = false,
        path,
        goToLastFrame
    } = useStoreState(state => state.animation.current);

    const setCurrentId = useStoreActions(actions => actions.animation.setCurrentId);

    const mainLottieRef = React.createRef();
    const loopLottieRef = React.createRef();

    const animationData = animations.get(path);

    if (!animationData) {
        throw new Error(`Missing animation data for ${path}`);
    }

    useEffect(() => {
        let loopLottieInstance;
        let lottieInstance = lottie.loadAnimation({
            container        : mainLottieRef.current,
            renderer         : `svg`,
            loop             : false,
            autoplay,
            animationData,
            rendererSettings : {
                preserveAspectRatio : `xMidYMid slice`
            }
        });

        // if (path !== animationHistory[animationHistory.length - 1]) {
        setCurrentId(path);

        loopLottieRef.current.style.opacity = 0;

        if (goToLastFrame) {
            const frameNumber = lottieInstance.getDuration(true);
            lottieInstance.goToAndStop(frameNumber, true);
        } else if (loop) {
            const loopAnimationData = animations.get(loop.path);

            if (!loopAnimationData) {
                throw new Error(`Missing loop animation data for ${loop.path}`);
            }

            loopLottieInstance = lottie.loadAnimation({
                container        : loopLottieRef.current,
                renderer         : `svg`,
                loop             : true,
                autoplay         : false,
                animationData    : loopAnimationData,
                rendererSettings : {
                    preserveAspectRatio : `xMidYMid slice`
                }
            });

            lottieInstance.addEventListener(`complete`, function onComplete () {
                setCurrentId(loop.path);
                lottieInstance.destroy();
                loopLottieRef.current.style.opacity = 1;
                loopLottieInstance.play();
            });
        }

        return () => {
            lottieInstance.destroy();
            if (loopLottieInstance) {
                loopLottieInstance.destroy();
            }
        };
    }, [loop, autoplay, path, goToLastFrame, setCurrentId, animationData, loopLottieRef, mainLottieRef]);

    return (
        <div className={`lottie-anim`} aria-hidden={true}>
            <div className="lottie-anim-main" ref={mainLottieRef}></div>
            <div className="lottie-anim-loop" ref={loopLottieRef}></div>
        </div>
    );
};

export default Lottie;
